<template>
  <div class="widget d-flex p-3">
    <button v-tooltip="{ title: $t('back') }" class="btn-icon me-1" @click="$router.back()">
      <FontAwesomeIcon icon="fa-light fa-arrow-left" />
    </button>
    <h2 class="textStyle h-auto">
      {{ $t("release_notes") }}
    </h2>
  </div>

  <div class="position-relative">
    <template v-if="Object.keys(release_notes).length">
      <ReleaseNotesItemBlockComponent v-for="note in release_notes" :key="note.id" :note="note" />
    </template>
    <div class="widget" v-else>
      <div class="widget-content">
        <p class="error-text">Pas de notes de version disponibles !</p>
      </div>
    </div>
    <BlockLoader :loading="loading" />
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import ReleaseNotesItemBlockComponent from "./ReleaseNotesItemBlockComponent.vue";
import { adminManager } from "@/services/admin/admin-manager";
import BlockLoader from "@/components/blocks/BlockLoader.vue";
import { mapActions } from "pinia";
import { useMainStore } from "@/store/main/main";

export default {
  name: "ReleaseNotesBlockComponent",
  components: { BlockLoader, FontAwesomeIcon, ReleaseNotesItemBlockComponent },
  data() {
    return {
      loading: false,
      release_notes: [],
    };
  },
  mounted() {
    this.initReleaseNotes();
  },
  methods: {
    initReleaseNotes() {
      this.loading = true;
      adminManager.list("release-note", false).then((res) => {
        this.release_notes = res;
        this.loading = false;
        this.setAppLoading(false);
      });
    },

    ...mapActions(useMainStore, {
      setAppLoading: "setAppLoading",
    }),
  },
};
</script>

<style lang="scss" scoped>
.relou {
  margin-left: auto;
  margin-right: auto;
  justify-content: center;
  align-self: center;
  align-items: center;
  font-size: 1.5rem;
  font-weight: 600;
  padding-bottom: 2rem;
}

.error-text {
  font-size: 18px;
  color: $dark;
  font-weight: 600;
  text-align: center;
  margin-bottom: 0;

  @include mobile {
    font-size: 14px;
    padding: 1rem;
  }
}
</style>
